<template>
    <div>
        <h4>READER’S DELIGHT</h4>
        <p>
            6p News + 2p Cal OR +6pg Cal<br />
            Color only<br />
            5 or 6 pages of custom-designed content<br />
            Newsletter Qty must be equal to Calendar Qty<br />
            includes up to 11,000 characters.<br />
            Special calendar pricing, listed below.
        </p>
        <el-row :gutter="30">
            <el-col :xl="10">
                <table class="w-full mt-20" style="max-width: 500px">
                    <thead>
                        <tr>
                            <td class="text-center">Quantity</td>
                            <td class="text-center">6 Pages of Newsletter</td>
                            <td class="text-center">Monthly Calendar</td>
                            <td class="text-center">Weekly Calendar</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in computedPrices">
                            <td class="text-center">{{ row.quantity }}</td>
                            <td v-for="price in row.prices">
                                <div class="el-input el-input--minimal-padding">
                                    <money
                                        v-model.number="price.price"
                                        v-bind="money"
                                        :disabled="
                                            !can(Permissions.EDIT_PRICING)
                                        "
                                        class="text-right el-input__inner"
                                    />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </el-col>
            <el-col :xl="14">
                <table class="w-full mt-20" style="max-width: 800px">
                    <thead>
                        <tr>
                            <td class="text-center">Quantity</td>
                            <td v-for="size in posterSizes" class="text-center">
                                Monthly<br />
                                {{ size.name }}
                            </td>
                            <td
                                v-for="size in weeklyCalendarAvailablePosterSizes"
                                class="text-center"
                            >
                                Weekly<br />
                                {{ size.name }}
                            </td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in computedPosterPrices">
                            <td class="text-center">{{ row.quantity }}</td>
                            <td v-for="price in row.prices">
                                <div class="el-input el-input--minimal-padding">
                                    <money
                                        v-model.number="price.price"
                                        v-bind="money"
                                        :disabled="
                                            !can(Permissions.EDIT_PRICING)
                                        "
                                        class="text-right el-input__inner"
                                    />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import * as Getters from "../../../store/constants/getters";
import * as ColorTypes from "../../../constants/color-types";
import { Money, VMoney } from "v-money";
import * as OrderableTypes from "../../../constants/orderable-types";
import * as NewsletterTypes from "../../../constants/newsletter-types";
import base_mixin from "./base";
import Sizes from "@/constants/sizes";

export default {
    mixins: [base_mixin],
    props: {
        form: {
            type: Object,
            required: true,
        },
    },
    directives: { money: VMoney },
    components: {
        Money,
    },
    data() {
        return {
            newsletter_type_id: 4,
            ColorTypes,
            OrderableTypes,
            money: {
                decimal: ".",
                thousands: ",",
                prefix: "$ ",
                suffix: "",
                precision: 2,
                masked: true,
            },
            base: {
                size_id: null,
                orderable_type: null,
                newsletter_type_id: 4,
                color_type: null,
                quantity: 0,
                newsletter_pages: null,
                max_chars: null,
                pricing_model_id: null,
                weekly_calendar: false,
                monthly_calendar: false,
            },
        };
    },
    computed: {
        ...mapState({
            sizes: (state) => state.sizes.data,
            prices: (state) => state.prices.data,
            pricing: (state) => state.config.settings.pricing,
        }),
        ...mapGetters([Getters.WEEKLY_CALENDAR_AVAILABLE_POSTER_SIZES]),
        posterSizes() {
            return this.$store.getters[Getters.POSTER_SIZES].filter(
                (item) =>
                    !_.includes([Sizes.size22x34, Sizes.size36x60], item.id)
            );
        },
        computedPrices() {
            let prices = [];
            let attributes = [
                { monthly_calendar: false, weekly_calendar: false },
                { monthly_calendar: true },
                { weekly_calendar: true },
            ];
            let quantities =
                this.pricing.newsletter_types[NewsletterTypes.READERS_DELIGHT]
                    .quantities;
            prices = _.map(quantities, (quantity) => {
                let prices = [];
                attributes.forEach((attr) => {
                    let price = _.find(this.form.prices, {
                        ...this.basePriceAttributes,
                        newsletter_type_id: 4,
                        size_id: null,
                        quantity,
                        ...attr,
                    });
                    if (price) {
                        prices.push(price);
                    }
                });
                return {
                    quantity,
                    prices,
                };
            });
            return prices;
        },
        computedPosterPrices() {
            let prices = [];
            prices = _.map(
                this.pricing.quantities.calendars.posters,
                (quantity) => {
                    let prices = [];
                    this.posterSizes.forEach((size) => {
                        let price = _.find(this.form.prices, {
                            ...this.basePriceAttributes,
                            newsletter_type_id: 4,
                            orderable_type: OrderableTypes.CALENDAR,
                            size_id: size.id,
                            quantity,
                            monthly_calendar: true,
                        });
                        if (price) {
                            prices.push(price);
                        }
                    });
                    this[
                        Getters.WEEKLY_CALENDAR_AVAILABLE_POSTER_SIZES
                    ].forEach((size) => {
                        let price = _.find(this.form.prices, {
                            ...this.basePriceAttributes,
                            newsletter_type_id: 4,
                            orderable_type: OrderableTypes.CALENDAR,
                            size_id: size.id,
                            quantity,
                            weekly_calendar: true,
                        });
                        if (price) {
                            prices.push(price);
                        }
                    });
                    return {
                        quantity,
                        prices,
                    };
                }
            );
            return prices;
        },
    },
};
</script>

<style scoped></style>
